import { ConfigurationDomainError } from './types'

export const compareCodeUnits = (left: string, right: string): number =>
  left < right ? -1 : left > right ? 1 : 0

const canonicalize = (value: unknown): unknown => {
  if (value === undefined) return undefined
  if (value === null || typeof value !== 'object') return value
  if (Array.isArray(value)) {
    return value.map(canonicalize).filter((item) => item !== undefined)
  }

  return Object.fromEntries(
    Object.entries(value)
      .filter(([, entry]) => entry !== undefined)
      .sort(([left], [right]) => compareCodeUnits(left, right))
      .map(([key, entry]) => [key, canonicalize(entry)]),
  )
}

export const canonicalJson = (value: unknown): string => {
  const json = JSON.stringify(canonicalize(value))
  if (json === undefined) {
    throw new ConfigurationDomainError(
      'INVALID_OPERATION',
      'Cannot canonicalize an undefined value',
    )
  }
  return json
}

export const hashCanonicalValue = async (value: unknown): Promise<string> => {
  const bytes = new TextEncoder().encode(canonicalJson(value))
  const digest = await crypto.subtle.digest('SHA-256', bytes)
  return [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

export const canonicalClone = <T>(value: T): T =>
  JSON.parse(canonicalJson(value)) as T
